import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { merge } from 'ts-deepmerge';
import { useController } from '@/hooks/useController';
import { useTheme } from '@/hooks/useTheme';
import { applyTranslationOverrides } from '@/i18n/applyTranslationOverrides';
import { languageSelector, initialUserConfig, userConfigState, } from '@/state/config';
import { injectScript } from '../../util/userway';
import { AppContainer } from '../AppContainer/AppContainer';
export const App = ({ userConfig }) => {
    const { notifyWidgetLoaded, notifyUserWayInit } = useController();
    const setUserConfig = useSetRecoilState(userConfigState);
    const language = useRecoilValue(languageSelector);
    const setinitialUserConfig = useSetRecoilState(initialUserConfig);
    const { notifyWidgetResize } = useController();
    useTheme();
    const { i18n } = useTranslation();
    const { enableAccessibilityWidget } = userConfig;
    useEffect(() => {
        if (enableAccessibilityWidget) {
            injectScript();
        }
    }, [enableAccessibilityWidget]);
    useEffect(() => {
        setinitialUserConfig(userConfig);
    }, [setinitialUserConfig, userConfig]);
    // Save the user config
    useEffect(() => {
        if (userConfig) {
            setUserConfig((prev) => merge({}, prev, userConfig));
        }
    }, [setUserConfig, userConfig]);
    // Change language and apply translation overrides after the locale loads
    useEffect(() => {
        const applyOverrides = () => {
            if (userConfig.translations) {
                applyTranslationOverrides(i18n, userConfig.translations);
            }
        };
        if (i18n === null || i18n === void 0 ? void 0 : i18n.changeLanguage) {
            i18n.changeLanguage(language, applyOverrides);
        }
        i18n.on('loaded', applyOverrides);
        return () => {
            i18n.off('loaded', applyOverrides);
        };
    }, [i18n, language, userConfig.translations]);
    useEffect(() => {
        document.addEventListener('userway:init_completed', notifyUserWayInit);
        return () => {
            document.removeEventListener('userway:init_completed', notifyUserWayInit);
        };
    }, [notifyUserWayInit]);
    useEffect(() => {
        // Publish an event to announce the widget was configured and rendered
        notifyWidgetLoaded();
    }, [notifyWidgetLoaded]);
    useEffect(() => {
        var _a;
        const alignment = userConfig.widget_alignment;
        // Normalize legacy shorthand values to their full form
        const legacyMap = {
            left: 'bottom-left',
            right: 'bottom-right',
        };
        const normalized = (_a = (alignment && legacyMap[alignment])) !== null && _a !== void 0 ? _a : alignment;
        const resizeData = {};
        if (normalized === 'bottom-left' || normalized === 'top-left') {
            resizeData.left = '0px';
        }
        if (normalized === 'top-left' || normalized === 'top-right') {
            resizeData.top = '0px';
        }
        if (Object.keys(resizeData).length > 0) {
            notifyWidgetResize(resizeData);
        }
    }, [notifyWidgetResize, userConfig]);
    return _jsx(AppContainer, {});
};
